import { expVal } from '@atlassian/jira-feature-experiments';

const isJiraSpreadsheetGroupSearchWarningsEnabled = {
	get(): boolean {
		return expVal('jira_spreadsheet_group_search_warnings_nin', 'isEnabled', false);
	},
};

export default isJiraSpreadsheetGroupSearchWarningsEnabled;
